import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Series, Size } from "devextreme-react/pie-chart";
import { AprEocTabIVA as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEocTabIVA = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const a1EndReasonField = () => {
    const propertyName = pn<AprResponseModel>("a1EndReason");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.a1EndReason} {formatPercentTotal(props.data?.a1EndReason, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const a2EndReasonField = () => {
    const propertyName = pn<AprResponseModel>("a2EndReason");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.a2EndReason} {formatPercentTotal(props.data?.a2EndReason, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const a3EndReasonField = () => {
    const propertyName = pn<AprResponseModel>("a3EndReason");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.a3EndReason} {formatPercentTotal(props.data?.a3EndReason, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const a4EndReasonField = () => {
    const propertyName = pn<AprResponseModel>("a4EndReason");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.a4EndReason} {formatPercentTotal(props.data?.a4EndReason, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const a5EndReasonField = () => {
    const propertyName = pn<AprResponseModel>("a5EndReason");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.a5EndReason} {formatPercentTotal(props.data?.a5EndReason, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const a6EndReasonField = () => {
    const propertyName = pn<AprResponseModel>("a6EndReason");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.a6EndReason}{" "}
        {formatPercentTotal(props.data?.a6EndReason, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">
          Secondary School Diploma   
        </Typography>
        <Grid container spacing="lg">
          <Grid item xs={11}>
            <Grid container spacing="lg">
              {props.data?.a1EndReason != null && (
                <Grid item xs={12}>
                  {a1EndReasonField()}
                </Grid>
              )}
              <GridBreak />

              {props.data?.a2EndReason != null && (
                <Grid item xs={12}>
                  {a2EndReasonField()}
                </Grid>
              )}

              {props.data?.a3EndReason != null && (
                <Grid item xs={12}>
                  {a3EndReasonField()}
                </Grid>
              )}

              {props.data?.a4EndReason != null && (
                <Grid item xs={12}>
                  {a4EndReasonField()}
                </Grid>
              )}

              {props.data?.a5EndReason != null && (
                <Grid item xs={12}>
                  {a5EndReasonField()}
                </Grid>
              )}

              {props.data?.a6EndReason != null && (
                <Grid item xs={12}>
                  {a6EndReasonField()}
                </Grid>
              )}

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

        </Grid>
      </Stack>
    </Card>
  );
};
